import { create } from "zustand";

type ErrorStore = {
  error: string | null;
  setError: (msg: string | null) => void;
};

export const useAppErrorStore = create<ErrorStore>((set) => ({
  error: null,
  setError: (msg) => set({ error: msg }),
}));
